module.exports = __webpack_public_path__ + "assets/img/zyrw06.75e4a406.png";